import {
  ToastErrorIcon,
  ToastSuccessIcon,
} from '~/components/component-library/Toast'
import { UserDisplay } from '~/components/component-library/UserDisplay'
import { useReviewStepData } from '~/components/create-workspace/steps/6_ReviewStep/useReviewStepData'
import { useRequiredActiveOrg } from '~/hooks/org'
import { getUserTreasuryPasskeyId } from '~/hooks/useSmartAccountSetupStep'
import { OrgMemberRole } from '~/types'

export const ReviewStepOwnerStatus = () => {
  const org = useRequiredActiveOrg()
  const { ownersMissingDetails, invitations } = useReviewStepData()

  const hasIssues = ownersMissingDetails.length > 0 || invitations.length > 0

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-2">
        <span className={hasIssues ? 'text-red-600' : 'text-green-600'}>
          {hasIssues ? <ToastErrorIcon /> : <ToastSuccessIcon />}
        </span>
        <span className="text-primary">
          {hasIssues ? (
            <>
              {ownersMissingDetails.length > 0 && (
                <>
                  {ownersMissingDetails.length} owner
                  {ownersMissingDetails.length > 1 ? 's have' : ' has'} not
                  finished onboarding
                </>
              )}
              {ownersMissingDetails.length > 0 && invitations.length > 0 && (
                <>, and </>
              )}
              {invitations.length > 0 && (
                <>
                  {invitations.length} invitation
                  {invitations.length > 1 ? 's are' : ' is'} pending
                </>
              )}
            </>
          ) : (
            'All owners have finished onboarding'
          )}
        </span>
      </div>

      {ownersMissingDetails.map((m) => {
        const hasPasskey = !!org.passkeys.find((p) => p.user?.id === m.id)

        if (!m.displayName || !hasPasskey) {
          return (
            <div key={m.id} className="flex items-center gap-1 pl-6">
              <UserDisplay user={m} layout="inline-text" /> needs to complete
              their profile
            </div>
          )
        } else if (!getUserTreasuryPasskeyId(m.id, org)) {
          return (
            <div key={m.id} className="flex items-center gap-1 pl-6">
              <UserDisplay user={m} layout="inline-text" /> needs to add a
              Treasury passkey
            </div>
          )
        } else {
          return null
        }
      })}

      {invitations
        .filter((i) => i.role === OrgMemberRole.Owner)
        .map((i) => (
          <div key={i.id} className="pl-6">
            <span className="font-medium">{i.email}</span> needs to accept their
            invite
          </div>
        ))}
    </div>
  )
}
